import { IonPage } from '@ionic/react';
import { useState } from 'react';

import AppleStore from '@/assets/imgs/seguridad-social/apple.png';
import GooglePlay from '@/assets/imgs/seguridad-social/google.png';
import Paso1 from '@/assets/imgs/seguridad-social/Paso1.png';
import Paso2 from '@/assets/imgs/seguridad-social/Paso2.png';
import Paso3 from '@/assets/imgs/seguridad-social/Paso3.png';
import Paso4 from '@/assets/imgs/seguridad-social/Paso4.png';
import Paso5 from '@/assets/imgs/seguridad-social/Paso5.png';
import Paso6 from '@/assets/imgs/seguridad-social/Paso6.png';
import Paso7 from '@/assets/imgs/seguridad-social/Paso7.png';
import Paso8 from '@/assets/imgs/seguridad-social/Paso8.png';
import Paso9 from '@/assets/imgs/seguridad-social/Paso9.png';
import Paso10 from '@/assets/imgs/seguridad-social/Paso10.png';
import { LuAlertTriangle, LuArrowLeftRight, LuCheck, LuClock, LuKeyRound, LuLogIn, LuMessageCircle, LuPencil, LuPhone, LuSave, LuShield, LuSmartphone } from 'react-icons/lu';

import PepperLogo from '@/assets/imgs/pepper-logo.svg';
import Button from '@/components/common/Button/Button';

import styles from './ActualizaDatosSS.module.scss';

const SS_PORTAL = 'https://portal.seg-social.gob.es/wps/portal/importass/importass/Categorias/Datos+personales';
const PDF_URL = '/assets/Guia_Seguridad_Social.pdf';
const TEL = 'tel:+34912161212';
const IOS_URL = 'https://apps.apple.com/es/app/cl-ve/id842624380';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=es.aeat.pin24h&hl=es';

const STEPS = [
  {
    n: 1, img: Paso1, Icon: LuLogIn,
    title: 'Entra en «Datos personales»',
    desc: 'Abre el portal Importass y pulsa «Acceder a datos personales».',
    tip: 'Abre directamente el portal «Datos personales» de la Seguridad Social.',
    tipHref: SS_PORTAL,
  },
  {
    n: 2, img: Paso4, Icon: LuMessageCircle,
    title: 'Comprueba tu móvil con «Vía SMS»',
    desc: 'Elige «Vía SMS» e introduce DNI/NIE, fecha de nacimiento y móvil. Te dirá si el número consta.',
    tip: '¿Error de fecha en Pepper? Suele ser que no tienes teléfono registrado.',
  },
  {
    n: 3, img: Paso8, Icon: LuKeyRound,
    title: 'Si no consta, identifícate con Cl@ve',
    desc: 'Si el móvil no consta o es diferente, vuelve a «Identifícate» y entra con Cl@ve Móvil: escanea el QR y confirma.',
    tip: 'Casi todos tienen Cl@ve desde los ERTE de 2020. Compruébalo antes.',
  },
  {
    n: 4, img: Paso7, Icon: LuPencil,
    title: 'Modifica tus datos de contacto',
    desc: 'En «Datos de contacto» pulsa Modificar y añade tu móvil. También te pedirá un correo.',
    tip: 'El correo es obligatorio para guardar los cambios.',
  },
  {
    n: 5, img: Paso10, Icon: LuSave,
    title: 'Guarda y vuelve a tu operación',
    desc: 'Pulsa «Guardar cambios» y vuelve a la web de Pepper para pasar la operación.',
    tip: 'Los datos quedan disponibles de inmediato para verificar la operación.',
  },
];

const CAPS = [
  { img: Paso1,  cap: 'Pulsa «Acceder a datos personales».' },
  { img: Paso2,  cap: 'Elige tu método de identificación.' },
  { img: Paso3,  cap: 'Selecciona «Vía SMS» para comprobar tu móvil.' },
  { img: Paso4,  cap: 'Introduce DNI/NIE, fecha de nacimiento y móvil.' },
  { img: Paso5,  cap: 'Escribe el código de seguridad que recibes por SMS.' },
  { img: Paso6,  cap: 'Si tu móvil consta, accedes a tu área personal.' },
  { img: Paso8,  cap: 'Si no consta, identifícate con Cl@ve Móvil: escanea el QR.' },
  { img: Paso9,  cap: 'Confirma la petición en la app Cl@ve de tu móvil.' },
  { img: Paso7,  cap: 'En «Datos de contacto», pulsa «Modificar».' },
  { img: Paso10, cap: 'Añade móvil y correo y pulsa «Guardar cambios».' },
];

const WHY = [
  { Icon: LuShield,     title: 'Sin papeleo',    text: 'Verificamos tu identidad con fuentes oficiales: nada de fotocopias ni desplazamientos.' },
  { Icon: LuSmartphone, title: 'Te avisamos a ti', text: 'Necesitamos tu móvil y tu correo reales para confirmarte la operación y los pagos.' },
  { Icon: LuClock,      title: 'En 5 minutos',   text: 'Actualizar tus datos en la Seguridad Social es rápido y solo se hace una vez.' },
];

const BRANCHES = [
  {
    id: 'ok',    tone: 'success', tag: 'TODO CORRECTO', Icon: LuCheck,
    title: 'Me ha llegado el SMS',
    lead: 'Tu teléfono ya está vinculado a la Seguridad Social.',
    body: 'No tienes que hacer nada más. Vuelve a la web de Pepper y pasa de nuevo la operación: tus datos verificarán sin problema.',
  },
  {
    id: 'none',  tone: 'error',   tag: 'NO CONSTA', Icon: LuPhone,
    title: 'No consta ningún teléfono',
    lead: 'No hay ningún número registrado a tu nombre.',
    body: 'Identifícate con Cl@ve Móvil (paso 3), entra en Datos de contacto y añade tu teléfono móvil y tu correo. Después guarda los cambios.',
  },
  {
    id: 'other', tone: 'warning', tag: 'OTRO NÚMERO', Icon: LuArrowLeftRight,
    title: 'Consta otro teléfono',
    lead: 'El número registrado no es el tuyo actual.',
    body: 'Identifícate con Cl@ve Móvil (paso 3), entra en Datos de contacto y sustituye el número antiguo por el correcto. No olvides el correo y guarda.',
  },
];

const FAQ = [
  {
    q: '¿Por qué Pepper necesita que mis datos estén en la Seguridad Social?',
    a: 'Para financiar sin papeleo verificamos tu identidad y tus datos de contacto directamente con fuentes oficiales. Si tu teléfono o tu correo no constan en la Seguridad Social, la operación no puede completarse de forma automática.',
  },
  {
    q: 'No tengo la app Cl@ve. ¿Qué hago?',
    a: 'Puedes descargar «Cl@ve» (Cl@ve Móvil) gratis en App Store o Google Play y registrarte. Si no quieres usarla, también puedes identificarte con DNIe o certificado digital desde la misma pantalla de «Identifícate».',
  },
  {
    q: 'No recuerdo si instalé Cl@ve en su día.',
    a: 'Es muy habitual. La mayoría de personas instaló Cl@ve en 2020 para gestionar los ERTE y luego no volvió a usarla. Busca el icono naranja en tu móvil antes de descartar esta opción: probablemente ya la tengas.',
  },
  {
    q: '¿Por qué me piden un correo electrónico al modificar?',
    a: 'El portal de la Seguridad Social exige un correo para guardar los cambios en los datos de contacto. Añádelo aunque solo quieras actualizar el teléfono: es obligatorio para poder pulsar «Guardar cambios».',
  },
  {
    q: 'Soy del comercio y al pasar la operación salta un error de fecha de nacimiento.',
    a: 'Ese error suele significar que el cliente no tiene ningún teléfono registrado en la Seguridad Social. Acompáñale en estos pasos para que lo dé de alta vía Cl@ve y, después, vuelve a pasar la operación.',
  },
  {
    q: '¿Cuánto tarda en actualizarse?',
    a: 'Los cambios quedan guardados al instante. En cuanto pulses «Guardar cambios» en el portal, puedes volver a Pepper y reintentar la operación.',
  },
];

function linkClave(text: string) {
  if (!text.includes('Cl@ve')) return text;
  const parts = text.split(/(Cl@ve(?:\sMóvil)?)/g);
  return parts.map((p, i) =>
    /^Cl@ve/.test(p) ? <a key={i} href="#clave" className={styles.claveLink}>{p}</a> : p,
  );
}

// ── Sub-components ──────────────────────────────────────────────────

function Nav({ onCta }: { onCta: () => void }) {
  return (
    <header className={styles.nav}>
      <div className={`${styles.shell} ${styles.navInner}`}>
        <img src={PepperLogo} alt="Pepper" className={styles.navLogo} />
        <div className={styles.navActions}>
          <a href="#pasos" className={styles.navLink}>Cómo hacerlo</a>
          <a href="#dudas" className={styles.navLink}>Dudas</a>
          <Button id="nav-cta" onClick={onCta} shape="round" className={styles.navCta}>
            Ir al portal
          </Button>
        </div>
      </div>
    </header>
  );
}

function Hero({ onCta }: { onCta: () => void }) {
  return (
    <section className={styles.hero}>
      <div className={`${styles.shell} ${styles.heroGrid}`}>
        <div className={styles.heroText}>
          <h1 className={styles.heroTitle}>
            Actualiza tu teléfono en la <span className={styles.red}>Seguridad Social</span>
          </h1>
          <p className={styles.heroSub}>
            Tu móvil y tu correo deben constar en la Seguridad Social. Te guiamos: se hace una vez y en unos minutos.
          </p>
          <div className={styles.heroBtns}>
            <Button id="hero-portal" onClick={onCta} shape="round">
              Acceder al portal de la SS
            </Button>
            <Button
              id="hero-how"
              color="dark"
              fill="outline"
              onClick={() => {
                const el = document.getElementById('pasos');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
              shape="round"
            >
              Ver cómo funciona
            </Button>
          </div>
        </div>
        <div className={styles.heroArt}>
          <div className={styles.browserChrome}>
            <div className={styles.browserBar}>
              <span className={styles.browserDots} />
              <span className={styles.browserUrl}>importass.seg-social.gob.es</span>
            </div>
            <img src={Paso1} alt="Portal Seguridad Social" className={styles.heroScreenshot} />
          </div>
        </div>
      </div>
    </section>
  );
}

function WhySection() {
  return (
    <section className={styles.why}>
      <div className={styles.shell}>
        <div className={styles.whyHeader}>
          <h2 className={styles.sectionH2}>¿Por qué te lo pedimos?</h2>
          <p className={styles.sectionSub}>
            Pepper verifica tus datos con fuentes oficiales. Por eso necesitamos que tu contacto
            esté al día en la Seguridad Social.
          </p>
        </div>
        <div className={styles.whyGrid}>
          {WHY.map((w) => (
            <div key={w.title} className={styles.whyCard}>
              <div className={styles.whyIcon}><w.Icon size={22} strokeWidth={2.75} /></div>
              <div>
                <h3 className={styles.whyTitle}>{w.title}</h3>
                <p className={styles.whyText}>{w.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Stepper({ onCta }: { onCta: () => void }) {
  const [step, setStep] = useState(0);
  const s = STEPS[step];
  return (
    <section className={styles.stepperSection}>
      <div className={styles.shell}>
        <div className={styles.stepperHeader}>
          <div className={styles.eyebrow}>Paso a paso</div>
          <h2 className={styles.sectionH2}>Cómo actualizar tus datos</h2>
        </div>
        <div id="pasos" className={styles.stepperProgress}>
          {STEPS.map((st, k) => (
            <button key={st.n} onClick={() => setStep(k)} className={styles.stepperTrack}>
              <div className={`${styles.stepperBar} ${k <= step ? styles.stepperBarActive : ''}`} />
              <div className={`${styles.stepperLabelRow} ${k === step ? styles.stepperLabelActive : ''}`}>
                <st.Icon size={15} color={k <= step ? 'var(--ion-color-pepper-red-6)' : 'var(--ion-color-pepper-gray-6)'} />
                <span>Paso {st.n}</span>
              </div>
            </button>
          ))}
        </div>
        <div className={styles.stepperGrid}>
          <div className={styles.stepperTextCol}>
            <div className={styles.stepperMeta}>
              <div className={styles.stepBadge}>{s.n}</div>
              <span className={styles.stepperCounter}>Paso {s.n} de {STEPS.length}</span>
            </div>
            <h3 className={styles.stepperTitle}>{linkClave(s.title)}</h3>
            <p className={styles.stepperDesc}>{linkClave(s.desc)}</p>
            {s.tip && (
              <div className={styles.tipBox}>
                <LuAlertTriangle size={16} className={styles.tipIcon} />
                <p className={styles.tipText}>
                  {s.tipHref
                    ? <a href={s.tipHref} target="_blank" rel="noopener noreferrer" className={styles.tipLink}>{s.tip} →</a>
                    : linkClave(s.tip)}
                </p>
              </div>
            )}
            <div className={styles.stepperNav}>
              <Button
                id="step-prev"
                color="dark"
                fill="outline"
                disabled={step === 0}
                onClick={() => setStep(Math.max(0, step - 1))}
                shape="round"
              >
                ← Anterior
              </Button>
              {step < STEPS.length - 1
                ? (
                  <Button
                    id="step-next"
                    onClick={() => setStep(Math.min(STEPS.length - 1, step + 1))}
                    shape="round"
                  >
                    Siguiente →
                  </Button>
                ) : (
                  <Button id="step-done" color="success" onClick={onCta} shape="round">
                    ¡Listo! Ir al portal
                  </Button>
                )}
            </div>
          </div>
          <div className={styles.stepperArt}>
            <div className={styles.browserChrome}>
              <div className={styles.browserBar}>
                <span className={styles.browserDots} />
                <span className={styles.browserUrl}>importass.seg-social.gob.es</span>
              </div>
              <img key={s.n} src={s.img} alt={s.title} className={styles.stepScreenshot} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function BranchBlock() {
  const [open, setOpen] = useState<string>('ok');
  const active = BRANCHES.find((b) => b.id === open)!;
  return (
    <section className={styles.branchSection}>
      <div className={styles.shell}>
        <div className={styles.branchHeader}>
          <div className={styles.eyebrow}>Según tu caso</div>
          <h2 className={styles.sectionH2}>¿Qué te ha pasado al comprobar por SMS?</h2>
          <p className={styles.sectionSub}>El mensaje del paso 2 te dice qué hacer. Elige tu situación.</p>
        </div>
        <div className={styles.branchGrid}>
          {BRANCHES.map((b) => (
            <button
              key={b.id}
              onClick={() => setOpen(b.id)}
              className={`${styles.branchCard} ${styles[`branchCard_${b.tone}`]} ${b.id === open ? styles.branchCardActive : ''}`}
            >
              <div className={styles.branchCardTop}>
                <div className={`${styles.branchIconWrap} ${styles[`branchIconWrap_${b.tone}`]}`}>
                  <b.Icon size={22} />
                </div>
                <span className={`${styles.branchTag} ${styles[`branchTag_${b.tone}`]}`}>{b.tag}</span>
              </div>
              <h3 className={styles.branchTitle}>{b.title}</h3>
              <p className={styles.branchLead}>{b.lead}</p>
            </button>
          ))}
        </div>
        <div className={`${styles.branchPanel} ${styles[`branchPanel_${active.tone}`]}`}>
          <div className={styles.branchPanelRow}>
            <div className={`${styles.branchIconWrap} ${styles[`branchIconWrap_${active.tone}`]}`}>
              <active.Icon size={22} />
            </div>
            <div>
              <strong className={styles.branchPanelTitle}>{active.title}</strong>
              <p className={styles.branchBody}>{linkClave(active.body)}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Carousel() {
  const [idx, setIdx] = useState(0);
  const [tab, setTab] = useState<'carrusel' | 'video'>('carrusel');
  const n = CAPS.length;
  const go = (d: number) => setIdx((p) => (p + d + n) % n);
  const VIDEO_URL = '/assets/Seguridad_Social.mp4';

  return (
    <section className={styles.mediaSection}>
      <div className={styles.shell}>
        <div className={styles.mediaHeader}>
          <h2 className={styles.sectionH2}>El proceso, captura a captura</h2>
        </div>
        <div className={styles.mediaTabs}>
          {(['carrusel', 'video'] as const).map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`${styles.mediaTab} ${tab === t ? styles.mediaTabActive : ''}`}
            >
              {t === 'carrusel' ? 'Capturas paso a paso' : 'Vídeo oficial'}
            </button>
          ))}
        </div>
        {tab === 'carrusel' ? (
          <div className={styles.carouselWrap}>
            <button className={styles.carArrow} onClick={() => go(-1)} aria-label="Anterior">‹</button>
            <div className={styles.carCard}>
              <div className={styles.carStage}>
                <img src={CAPS[idx].img} alt={CAPS[idx].cap} className={styles.carImg} />
              </div>
              <div className={styles.carCapRow}>
                <div className={styles.stepBadge}>{idx + 1}</div>
                <p className={styles.carCap}>{CAPS[idx].cap}</p>
              </div>
            </div>
            <button className={styles.carArrow} onClick={() => go(1)} aria-label="Siguiente">›</button>
          </div>
        ) : (
          <div className={styles.videoWrap}>
            <video controls preload="none" poster={Paso1} className={styles.video}>
              <source src={VIDEO_URL} />
            </video>
            <p className={styles.videoCaption}>
              Vídeo: «Consulta y actualización de datos personales» · Seguridad Social.
            </p>
          </div>
        )}
        <div className={styles.carDots}>
          {CAPS.map((_, k) => (
            <button
              key={k}
              onClick={() => setIdx(k)}
              aria-label={`Ir a ${k + 1}`}
              className={`${styles.carDot} ${k === idx ? styles.carDotActive : ''}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function FaqSection() {
  const [open, setOpen] = useState<number>(0);
  return (
    <section id="dudas" className={styles.faqSection}>
      <div className={styles.shell}>
        <div className={styles.faqGrid}>
          <div>
            <h2 className={styles.sectionH2}>Dudas frecuentes</h2>
            <p className={styles.sectionSub}>Lo que más preguntan clientes y comercios sobre actualizar los datos.</p>
          </div>
          <div>
            {FAQ.map((f, k) => (
              <div key={k} className={styles.faqItem}>
                <button
                  onClick={() => setOpen(open === k ? -1 : k)}
                  className={styles.faqQuestion}
                >
                  <span>{linkClave(f.q)}</span>
                  <span className={`${styles.faqChevron} ${open === k ? styles.faqChevronOpen : ''}`}>›</span>
                </button>
                <div className={`${styles.faqAnswer} ${open === k ? styles.faqAnswerOpen : ''}`}>
                  <p>{linkClave(f.a)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function ClaveSection() {
  return (
    <section id="clave" className={styles.claveSection}>
      <div className={styles.shell}>
        <div className={`${styles.shell} ${styles.claveGrid}`}>
          <div>
            <div className={styles.eyebrow}>App Cl@ve Móvil</div>
            <h2 className={styles.sectionH2}>Descarga la app Cl@ve Móvil</h2>
            <p className={styles.sectionSub}>
              La necesitas para identificarte cuando tu teléfono no consta en la Seguridad Social.
              Es gratuita y muchos ya la tienen desde los ERTE de 2020: busca el icono naranja antes
              de descargarla.
            </p>
          </div>
          <div className={styles.claveBtns}>
            <a href={IOS_URL} target="_blank" rel="noopener noreferrer" className={styles.storeBtn}>
              <img src={AppleStore} alt="Consíguelo en el App Store" />
            </a>
            <a href={ANDROID_URL} target="_blank" rel="noopener noreferrer" className={styles.storeBtn}>
              <img src={GooglePlay} alt="Disponible en Google Play" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function FinalCta({ onCta }: { onCta: () => void }) {
  return (
    <section className={styles.ctaSection}>
      <div className={styles.shell}>
        <div className={styles.ctaBox}>
          <div className={styles.ctaAccent} />
          <div className={styles.ctaSplit}>
            <div>
              <h2 className={styles.ctaTitle}>Un paso más y tu financiación está lista</h2>
              <p className={styles.ctaSub}>
                Confirma tu móvil para terminar tu financiación con Pepper. Es rápido y no tienes que rellenar nada más.
              </p>
              <div className={styles.ctaActions}>
                <Button id="cta-portal" onClick={onCta} shape="round" className={styles.ctaBtn}>
                  Confirmar mi móvil →
                </Button>
                <a href={PDF_URL} target="_blank" rel="noopener noreferrer" className={styles.ctaPdfLink}>
                  Descargar la guía en PDF
                </a>
              </div>
            </div>
            <div className={styles.ctaDivider} />
            <div>
              <h3 className={styles.ctaPhoneTitle}>¿Alguna pregunta?</h3>
              <p className={styles.ctaPhoneSub}>
                Llámanos al{' '}
                <a href={TEL} className={styles.ctaPhoneNum}>912 16 12 12</a>
                {' '} o contacta con tu comercial. Estamos aquí para ayudarte a terminar.
              </p>
              <a href={TEL} className={styles.ctaPhoneLink}><LuPhone size={16} /> Llamar al 912 16 12 12</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <img src={PepperLogo} alt="Pepper" className={styles.footerLogo} />
        <p className={styles.footerCopy}>
          Copyright 2026 Pepper Finance Corporation, S.L.U. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}

// ── Page ────────────────────────────────────────────────────────────

export const ActualizaDatosSS = () => {
  const openPortal = () => window.open(SS_PORTAL, '_blank', 'noopener,noreferrer');

  return (
    <IonPage>
      <div className={styles.page}>
        <Nav onCta={openPortal} />
        <Hero onCta={openPortal} />
        <Stepper onCta={openPortal} />
        <BranchBlock />
        <WhySection />
        <Carousel />
        <FaqSection />
        <FinalCta onCta={openPortal} />
        <ClaveSection />
        <Footer />
      </div>
    </IonPage>
  );
};
